import { trackHeapEvent } from '@ratehub/base-ui';


/**
 * 'Loan Web Click'-specific call to `trackHeapEvent`.
 * @param {LoanShape} loan
 * @param {string} loan.applyURL
 * @param {string} loan.slug
 * @param {object} loan.provider
 * @param {string} provider.name
 * @param {boolean} loan.isMonetized
 */
function trackHeapEventForLoans({ applyURL, slug, provider, isMonetized }) {
    trackHeapEvent('Loan Web Click', {
        href: applyURL,
        slug: slug,
        provider: provider.name,
        monetized: isMonetized.toString(),
    });
}

export default trackHeapEventForLoans;
